export const environment = {
  production: true,
  firebase:{
    apiKey: "AIzaSyDlMw0-DH1kQT5jUZqMB5FVlOhkZ4JuVEo",
    authDomain: "world-top-docs-app.firebaseapp.com",
    projectId: "world-top-docs-app",
    storageBucket: "world-top-docs-app.appspot.com",
    messagingSenderId: "513781625074",
    appId: "1:513781625074:web:7c1c29a4860c6d219c206b",
    measurementId: "G-XFM7HN6YJ9"
  },
  firebase_dev:{
    apiKey: "AIzaSyC3fom7LcItn_jzlyjCS85UmUfuEjTg5PA",
    authDomain: "world-top-docs-dev.firebaseapp.com",
    projectId: "world-top-docs-dev",
    storageBucket: "world-top-docs-dev.appspot.com",
    messagingSenderId: "169810414996",
    appId: "1:169810414996:web:79ebe20835fc9209a61381"
  }
};
